const locale = () => {
    const html = document.documentElement;
    const locales = [html.lang, html.dataset.lang, html.dataset.locale];
    if (locales.some(value => value?.toLowerCase().startsWith('pl'))) {
        return 'pl';
    }
    if (locales.some(value => value?.toLowerCase().startsWith('de'))) {
        return 'de';
    }
    return 'cs';
};

const messages = {
    cs: {
        companyNotFound: 'Firma nebyla nalezena',
        companyLookupFailed: 'Firmu se nepodařilo ověřit',
    },
    pl: {
        companyNotFound: 'Nie znaleziono firmy',
        companyLookupFailed: 'Nie udało się zweryfikować firmy',
    },
    de: {
        companyNotFound: 'Unternehmen nicht gefunden',
        companyLookupFailed: 'Das Unternehmen konnte nicht überprüft werden',
        companyLookupUnavailable: 'Die Registersuche ist derzeit nicht verfügbar. Bitte geben Sie die Unternehmensdaten manuell ein.',
        companyLookupPlaceholder: 'Firmenname eingeben',
        companyLookupButton: 'Im Register suchen',
        companyLookupHint: 'Wenn kein passender Eintrag erscheint, können Sie die Unternehmensdaten unten manuell eingeben.',
        companyLookupShortQuery: 'Bitte geben Sie mindestens drei Zeichen ein.',
        companyLookupSearching: 'Suche im Unternehmensregister …',
        companyLookupNoResults: 'Kein passender Eintrag gefunden. Bitte geben Sie die Unternehmensdaten unten manuell ein.',
        companyLookupSelect: 'Diesen Eintrag verwenden',
        companyLookupSelected: 'Unternehmensdaten übernommen. Bitte prüfen und ergänzen Sie die Angaben.',
    },
};

export const advertiserText = key => messages[locale()][key];
